import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import useLang from "../hooks/useLang";
import LanguageSwitcher from "../components/LanguageSwitcher";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("errorGeneric"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col dot-grid">
      <div className="flex justify-end p-6">
        <LanguageSwitcher small />
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="flex flex-col items-center mb-10">
            <Logo size="lg" tagline="Il tuo gemello cognitivo" />
          </div>
          <div className="bg-white border border-zinc-200 rounded-md p-8">
            <div className="overline mb-3">/// {t("register")}</div>
            <h2 className="font-heading text-2xl tracking-tight mb-1">{t("registerTitle")}</h2>
            <p className="text-zinc-500 text-sm mb-8">{t("registerSubtitle")}</p>
            <form onSubmit={submit} className="space-y-5">
              <div className="space-y-2">
                <Label className="overline">{t("name")}</Label>
                <Input required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name-input" className="rounded-md border-zinc-200 h-11" placeholder="Mario Rossi" />
              </div>
              <div className="space-y-2">
                <Label className="overline">{t("email")}</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email-input" className="rounded-md border-zinc-200 h-11" placeholder="you@company.com" />
              </div>
              <div className="space-y-2">
                <Label className="overline">{t("password")}</Label>
                <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password-input" className="rounded-md border-zinc-200 h-11" />
              </div>
              <Button type="submit" disabled={loading} data-testid="register-submit-btn" className="w-full h-11 bg-zinc-950 hover:bg-zinc-800 rounded-md font-medium gap-2">
                {loading ? t("loading") : t("register")} <ArrowRight size={16} />
              </Button>
            </form>
          </div>
          <p className="text-sm text-zinc-500 mt-6 text-center">
            {t("haveAccount")}{" "}
            <Link to="/login" className="text-zinc-950 underline underline-offset-4" data-testid="go-to-login">{t("login")}</Link>
          </p>
        </div>
      </div>
      <div className="overline text-center py-6">/// EST. 2026 · cognitiveclone.eu</div>
    </div>
  );
}
